<template>
  <div>
    <v-row>
      <v-col cols="2">
        <v-select
          v-model="myData.status"
          :items="asg.status"
          item-text="name"
          item-value="value"
          label="状态"
          @change="$emit('query')"
        ></v-select>
      </v-col>
      <v-col cols="2">
        <v-text-field
          v-model="myData.projectNo"
          label="项目编号"
        ></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-text-field
          v-model="myData.contractNo"
          label="合同编号"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-btn color="primary" @click="query">查询</v-btn>
        <v-btn color="primary" @click="reset" class="ml-5">重置</v-btn>
        <v-btn color="primary" @click="batchConfirm" class="ml-5" v-if="isBatch"
          >批量确认</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { asg } from "@/plugins/chart";
export default {
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    isBatch() {
      return this.asg.statusDict.waitConfirm == this.myData.status;
    },
  },
  watch: {
    data(newVal) {
      this.myData = newVal;
    },
  },
  data() {
    return {
      asg,
      myData: this.data,
    };
  },
  components: {},
  methods: {
    query() {
      this.$emit("query");
    },
    reset() {
      this.$emit("reset");
    },
    batchConfirm() {
      this.$emit("batchConfirm");
    },
  },
};
</script>
